"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  downloadAll: 'Скачать все',
  previousFile: 'Предыдущий',
  nextFile: 'Следующий'
};